import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Button,
  Label,
  Icon,
  Segment,
  Dimmer,
  Loader,
  Image,
  Form,
  Message,
  Input,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { DataGrid, GridColumn } from 'rc-easyui';

import TimeUtils from '../../helper/TimeUtils';
import ApiUtils from '../../helper/ApiUtils';
import ProjectUtils from '../../helper/ProjectUtils';
import Spinner from '../common/Spinner';
import lockIcon from '../../images/icon/lockIcon.png';

//alert
import 'react-confirm-alert/src/react-confirm-alert.css';
import Popup from 'reactjs-popup'; // Import css

const md5 = require('md5');

class ProjectsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isAdmin: false,
      errors: {}, 
      data: [],
      projectArray: [],
      allProjectDetialArray: [], //伺服器上整理出來的資料,

      Changeloading: false,
      isOpenPassword: false,
      changePasswordError: false,
      old_password: '',
      new_password: '',
      confirm_password: '',
    };
    
  }

  async componentDidMount() {
    const { user } = this.props.auth;
    const email = user['email'];

    if (email.includes('thesubpro.com') === true) {
      await this.setState({ isAdmin: true });
    }

    //整理出專案列表資料
    const ProjectInfo = ProjectUtils.getEditingProjectInfo(this.props.listData);

    await this.setState({ projectArray: ProjectInfo['projectArray'] });
    
    await this.setState({ data: ProjectInfo['listView'] }); 
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  render() {
    const { loading, isAdmin } = this.state;
    const { user } = this.props.auth;
    const email = user['email'];

    let titleObj =
      this.props.project.homeReviewStatusList[this.props.project.statusValue];

    let buttonWidth = 94;

    // console.log(`this.state.data ${JSON.stringify(this.state.data)}`);
    return (
      <div className='mt-3 position-relative '>
        <div className='mt-3 position-relative '>
          <Button
            size={'tiny'}
            className='position-fixed'
            style={{ top: '10px', right: '10px' }}
            secondary
            onClick={() => {
              this.setState({ isOpenPassword: true });
            }}
          >
            Change Password
          </Button>

          {email.includes('thesubpro.com') === true ? (
            <div
              className='position-fixed'
              style={{ top: '10px', right: '180px' }}
            >
              <Link to={'/client'} target='_blank'>
                <div className='float-right p-2'>Client</div>
              </Link>

              <Link to={'/style'} target='_blank'>
                <div className='float-right p-2'>Style</div>
              </Link>

              <Link to={'/language'} target='_blank'>
                <div className='float-right p-2'>Language</div>
              </Link>
            </div>
          ) : null}

          <Popup
            open={this.state.isOpenPassword}
            modal
            closeOnDocumentClick
            onClose={() => {
              this.setState({ isOpenPassword: false });
            }}
            contentStyle={{ width: '400px', padding: '15px' }}
          >
            <Form
              error={this.state.changePasswordError}
              style={{ width: '400px' }}
              className={'mt-3'}
              // onSubmit={this.handleSubmit}
            >
              <Form.Field className={'mt-3'}>
                <label>Old Password</label>

                <Input
                  icon='unlock'
                  iconPosition='left'
                  autoFocus
                  placeholder='Old Password'
                  value={this.state.old_password}
                  onChange={(e) => {
                    this.setState({ old_password: e.target.value });
                  }}
                  type='password'
                />
              </Form.Field>

              <Form.Field className={'mt-3'}>
                <label>New Password</label>
                <Input
                  icon='unlock'
                  iconPosition='left'
                  placeholder='New Password'
                  value={this.state.new_password}
                  onChange={(e) => {
                    this.setState({ new_password: e.target.value });
                  }}
                  type='password'
                />
              </Form.Field>
              <Form.Field className={'mt-3'}>
                <label>Confirm Password</label>
                <Input
                  icon='unlock'
                  iconPosition='left'
                  placeholder='Confirm Password'
                  value={this.state.confirm_password}
                  onChange={(e) => {
                    this.setState({ confirm_password: e.target.value });
                  }}
                  type='password'
                />
              </Form.Field>

              <Message error header='Error' content='Password Change Error' />

              <Form.Field className={' w-100'}></Form.Field>

              {this.state.Changeloading === true ? (
                <Spinner />
              ) : (
                <Button
                  className={'mt-5 w-100'}
                  primary
                  type='button'
                  onClick={async () => {
                    if (
                      this.state.new_password !== this.state.confirm_password
                    ) {
                      alert('Confirm password Error');
                      return;
                    }

                    if (
                      this.state.old_password === '' ||
                      this.state.new_password === '' ||
                      this.state.confirm_password === ''
                    ) {
                      return;
                    }

                    try {
                      this.setState({ Changeloading: true });

                      const { user } = this.props.auth;
                      const { email } = user;

                      const res = await ApiUtils.post_sql(
                        `${ApiUtils.post_ChangePassword}`,
                        {
                          fEmail: email,
                          fPwd: md5(this.state.old_password),
                          newfPwd: md5(this.state.confirm_password),
                        }
                      );

                      if (res === 'True') {
                        this.props.history.push('/editor');

                        this.setState({ isOpenPassword: false });

                        localStorage.removeItem('jwtToken');
                        localStorage.removeItem('projectListData');
                        localStorage.removeItem('playerEditingData');
                      } else {
                        this.setState({ changePasswordError: true });
                        this.setState({ Changeloading: false });
                      }
                    } catch (err) {
                      //console.log(`get_sql err ${err}`);
                    }
                    this.setState({ Changeloading: false });
                  }}
                >
                  Change Account Password
                </Button>
              )}
            </Form>
          </Popup>
        </div>

        <div className='p-3'>
          {loading === true ? (
            <div>
              <Segment>
                <Dimmer active inverted>
                  <Loader inverted>Loading</Loader>
                </Dimmer>
                <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
              </Segment>
            </div>
          ) : (
            /** data 為所呈現的列表內容 */
            <DataGrid
              filterable
              data={this.state.data}
              style={{ height: `${window.innerHeight - 100}px` }}
              pagination
              pageSize={30}
            >
              <GridColumn field='Id' title='Id' width={35} sortable />
              <GridColumn
                field='SubType'
                title=' '
                width={42}
                render={({ row }) => {
                  const { SubType } = row;
                  return SubType === 1 ? (
                    <Label size={'mini'}>ttml</Label>
                  ) : null;
                }}
              />
              <GridColumn
                field='ProjectTitle'
                title='Title'
                width={220}
                sortable
              />
              <GridColumn field='Season' title='Season' width={80} sortable />
              <GridColumn field='Episode' title='Episode' width={80} sortable />
              <GridColumn
                field='SourceLanguage'
                title='Source Language'
                width={180}
                sortable
              />
              <GridColumn
                field='TargetLanguage'
                title='Target Language'
                width={180}
                sortable
              />

              {isAdmin === true ? (
                <GridColumn
                  field='fDueDate'
                  title='Due Date'
                  width={130}
                  sortable
                  render={({ row }) => {
                    const { fDueDate } = row;
                    let fDueDateString = TimeUtils.setTaiwan(fDueDate);
                    return fDueDateString;
                    // return  fDueDate;
                  }}
                />
              ) : (
                <GridColumn
                  rowCss={'display_none'}
                  width={0}
                  showColumn={false}
                  field='fDueDate'
                  title='Due Date'
                  sortable
                  render={({ row }) => {
                    return '';
                  }}
                />
              )}

              {/*<GridColumn field="worker" title="Assignee" sortable></GridColumn>*/}
              <GridColumn
                field='status'
                title='Freelancer'
                render={({ row }) => {
                  const { Step } = row;
                  const showMessage = Step.map((request, rowIndex) => {
                    const { projectDetial, worker } = request;
                    const { fId, status, fDueDate, isTimecodeLock } =
                      projectDetial;
                    let fDueDateString = TimeUtils.setTaiwan(fDueDate);
                    // let fDueDateString = fDueDate;
                    let EditorBtn;
                    let statusMessage;

                    /*用 fId 取出該專案的 tIndex*/
                    let tIndex = 0;
                    this.props.listData.map((data, index) => {
                      const { projectDetial } = data;
                      const qfId = projectDetial.fId;

                      if (qfId == fId) {
                        tIndex = index;
                      }
                    });
                    //    console.log("用 fId 取出該專案的 tIndex");
                    //    console.log(this.props.listData.length);
                    //    console.log(tIndex);

                    /**
                     * 如果上一步 ,step1 以後如果上一步完成才顯示
                     * 但管理者要看到
                     * */

                    const { user } = this.props.auth;
                    const email = user['email'];
                    if (email.includes('thesubpro.com') === true) {
                    } else {
                      if (rowIndex > 0) {
                        const lastObj = Step[rowIndex - 1];
                        const projectDetial = lastObj['projectDetial'];
                        const laststatus = projectDetial.status;

                        if (
                          parseFloat(laststatus) === 0 ||
                          parseFloat(laststatus) === 1
                        ) {
                          return <div />;
                        }
                      }
                    }

                    if (parseFloat(status) === 0) {
                      statusMessage =
                        this.state.loading === true ? (
                          <Spinner />
                        ) : (
                          <Button
                            style={{ width: `${buttonWidth}px` }}
                            size={'tiny'}
                            type='button'
                            color={'blue'}
                            onClick={async () => {
                              await this.setState({ loading: true });

                              await ApiUtils.get_sql(
                                `${ApiUtils.get_AcceptCase}?fProjectDetialId=${fId}&status=1`
                              );

                              window.location.reload();

                              await this.setState({ loading: false });
                            }}
                          >
                            Accept
                          </Button>
                        );
                      EditorBtn = (
                        <Button size={'tiny'} disabled={true}>
                          Editor
                        </Button>
                      );
                    } else if (parseFloat(status) === 1) {
                      statusMessage = (
                        <Button
                          style={{ width: `${buttonWidth}px` }}
                          type='button'
                          size={'tiny'}
                          color={'green'}
                        >
                          Processing
                        </Button>
                      );

                      EditorBtn = (
                        <Link to={`/translations/0/${tIndex}`} target='_blank'>
                          <div
                            onClick={() => {
                              /**
                               * 儲存用戶操作專案資料
                               * */
                              window.EditingProjectInfo = JSON.stringify(row);
                            }}
                          >
                            <u>Editor</u>
                          </div>
                        </Link>
                      );
                    } else if (parseFloat(status) === 2) {
                      statusMessage = (
                        <Button
                          style={{ width: `${buttonWidth}px` }}
                          type='button'
                          size={'tiny'}
                          color={'yellow'}
                        >
                          Completed
                        </Button>
                      );

                      EditorBtn = (
                        <Link to={`/translations/0/${tIndex}`} target='_blank'>
                          <div
                            onClick={() => {
                              /**
                               * 儲存用戶操作專案資料
                               * */
                              window.EditingProjectInfo = JSON.stringify(row);
                            }}
                          >
                            <u>Editor</u>
                          </div>
                        </Link>
                      );
                    }

                    return (
                      <div className={'p-2'}>
                        <span style={{ width: '80px' }}>
                          {' '}
                          <small className='text-black-50 '>{fId}</small>{' '}
                        </span>
                        {statusMessage}

                        <Label>
                          <Icon name='clock outline' /> {fDueDateString}
                        </Label>

                        {worker['fName']}

                        {parseFloat(isTimecodeLock) === 1 ? (
                          <small
                            style={{ fontSize: '8px', paddingLeft: '5px' }}
                          >
                            / TC
                            <img
                              style={{ paddingLeft: '2px' }}
                              src={lockIcon}
                              width={12}
                            />
                          </small>
                        ) : (
                          ''
                        )}

                        <div className={'float-right'}>{EditorBtn}</div>
                      </div>
                    );
                  });

                  return showMessage;
                }}
              />
            </DataGrid>
          )}
        </div>
      </div>
    );
  }
}

ProjectsList.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  project: state.project,
});

export default connect(mapStateToProps, {})(withRouter(ProjectsList));



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectsList.js